/* eslint-disable angular/window-service */
/* eslint-disable angular/document-service */
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';

function UserDropdown({
    adminRole = false, users, initialUserId, isLoaded,
}) {
    const [selectedUser, setSelectedUser] = useState(initialUserId);
    const [selectedUserName, setName] = useState('');
    const [isExpanded, setIsExpanded] = useState(false);
    const [disabled, setDisabled] = useState(isLoaded);
    const [data, setData] = useState([]);
    useEffect(() => {
        setDisabled(isLoaded);
    }, [isLoaded]);
    function openDropdown() {
        var dropdownMenu = document.getElementById('dropdown-menu');
        dropdownMenu.style.display = 'block';
    }

    function closeDropdown() {
        var dropdownMenu = document.getElementById('dropdown-menu');
        dropdownMenu.style.display = 'none';
    }
    function toggleDropdown() {
        var dropdownMenu = document.getElementById('dropdown-menu');
        if (dropdownMenu.style.display === 'none') {
            openDropdown();
            setIsExpanded(true);
        } else {
            closeDropdown();
            setIsExpanded(false);
        }
    }

    window.addEventListener('DOMContentLoaded', function () {
        var liElements = document.querySelectorAll('#dropdown-menu li');
        liElements.forEach(function (li) {
            li.addEventListener('click', closeDropdown);
        });
    });
    window.addEventListener('DOMContentLoaded', function () {
        var dropdownContainer = document.getElementById('dropdown-container');
        dropdownContainer.addEventListener('click', closeDropdown);
    });

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(
                    'https://jsonplaceholder.typicode.com/users',
                );
                await response.json();
                setData(users);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchData();
    }, []);

    const handleSelectUser = (userId, userName) => {
        setSelectedUser(userId);
        setName(userName);
        closeDropdown();
    };

    return (
        <>
            {adminRole && (
                <div>
                    <div
                        className='dropdown margin-t-8px'
                        id='dropdown-container'
                    >
                        <button
                            className='input-dropdown-toggle video-solution-dropdown dropdown__toggle dropdown-toggle'
                            data-toggle='dropdown'
                            aria-haspopup='true'
                            aria-expanded='false'
                            type='button'
                            onClick={toggleDropdown}
                            id='selected-user'
                            value={selectedUserName}
                            disabled={disabled}
                        >
                            {selectedUser
                                ? data.find((user) => user.id === selectedUser).name
                                : 'Select a User'}
                            <i
                                className={
                                    isExpanded
                                        ? 'dropdown__toggle-indicator fa fa-angle-up'
                                        : 'dropdown__toggle-indicator fa fa-angle-down'
                                }
                                aria-hidden='true'
                            ></i>
                        </button>
                        <ul
                            className='dropdown__menu dropdown__menu--selectable'
                            id='dropdown-menu'
                            role='menu'
                        >
                            {data
                && data.map((user) => (
                    <li
                        key={user.id}
                        id={user.id}
                        className={
                            selectedUser === user.id
                                ? 'dropdown__menu-item selected'
                                : 'dropdown__menu-item'
                        }
                        onClick={() => handleSelectUser(user.id, user.name)}
                    >
                        {user.name}
                    </li>
                ))}
                        </ul>
                    </div>
                </div>
            )}
        </>
    );
}

UserDropdown.propTypes = {
    adminRole: PropTypes.bool,
    users: PropTypes.array,
    initialUserId: PropTypes.number,
    isLoaded: PropTypes.bool,
};

export default UserDropdown;
